import * as React from 'react';
import theme from '../theme/theme';
import { Box, useMediaQuery } from '@mui/material';

const ButtonGroupPills = (props) => {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box 
    sx={{display: 'block', backgroundColor: theme.palette.primary.contrastText, padding: '8px 10px 8px 10px', borderRadius: isSmUp ? '50px' : '30px'}}>

      {props.buttons.map((b) => (
        <Box variant={"contained"} key={b.title}
            sx={{ 
                display: 'inline-block',
                textAlign: 'center',
                borderRadius: '50px', 
                padding: isSmUp ? '8px 28px 8px 28px' : '4px 28px 4px 28px', 
                width: isSmUp ? '33.3%' : '100%',
                fontWeight: '700', 
                fontSize: isMdUp ? '15px' : '14px',
                backgroundColor: b.id === props.selected ? theme.palette.primary.main : 'transparent',
                color: b.id === props.selected ? theme.palette.primary.contrastText : theme.palette.grey[600],
                '&:hover': /*b.id === props.selected ?
                  { backgroundColor: theme.palette.primary.contrastText, cursor: 'pointer' } :*/
                  { backgroundColor: theme.palette.primary.main, cursor: 'pointer', color: theme.palette.primary.contrastText }
            }}
            onClick={e => props.click(b.id)}>
                {b.title}<br/>
                <span style={{fontSize: '11px', fontWeight: '400'}}>{b.tiny}</span>
        </Box>
      ))}        
    </Box>
  );
};
export default ButtonGroupPills;